module.exports = __webpack_public_path__ + "static/media/67.1fa68d40.jpg";